<script setup lang="ts" generic="T">
import YscInputGroup from './YscInputGroup.vue'
import YscInputCheckbox from './YscInputCheckbox.vue'
import { defineModel } from '#imports'

interface Props {
  name: string
  options?: {
    value: T
    text: string
    disabled?: boolean
  }[]
  disabled?: boolean
  required?: boolean
  layoutColumn?: boolean
}

const modelValue = defineModel<T[]>({ required: true })

withDefaults(defineProps<Props>(), {
  options: () => [],
  disabled: false,
  required: false,
  layoutColumn: false,
})
</script>

<template>
  <YscInputGroup
    :required="required"
    :disabled="disabled"
  >
    <template
      v-if="$slots.default"
      #default
    >
      <slot />
    </template>

    <template #inputBlock>
      <div
        :class="layoutColumn ? 'columns-2 space-y-2' : 'flex flex-wrap gap-4'"
        class="relative"
      >
        <YscInputCheckbox
          v-for="option in options"
          :id="`${name}_${option.value}`"
          :key="`${name}_${option.value}`"
          v-model="modelValue"
          :name="name"
          :value="option.value"
          :disabled="disabled || option.disabled"
          is-block
        >
          {{ option.text }}
        </YscInputCheckbox>

        <input
          v-if="required"
          type="radio"
          :checked="modelValue !== null && modelValue.length > 0 ? true : false"
          tabindex="-1"
          class="absolute inset-0 -z-10 opacity-0"
          :name="name"
          required
        >
      </div>
    </template>

    <template
      v-if="$slots.description"
      #description
    >
      <slot name="description" />
    </template>
  </YscInputGroup>
</template>
